var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "current-subscription-wrapper" },
    [
      _c("h2", { staticClass: "current-subscription-title" }, [
        _vm._v(" " + _vm._s(_vm.$t("pages.billing.currentSubscription")) + " "),
      ]),
      _c(
        "ib-card",
        {
          staticClass: "current-subscription-card",
          attrs: { animation: false },
        },
        [
          _c(
            "div",
            { staticClass: "d-flex justify-space-between" },
            [
              _vm.subscriptionIsFreeTrial
                ? _c("div", [
                    _c(
                      "p",
                      {
                        staticClass:
                          "m-0 mb-1 subscription-plan-name font-outfit-medium",
                      },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.$t("pages.billing.freePlan")) + " "
                        ),
                      ]
                    ),
                    !_vm.subscriptionIsFreeTrialExpired
                      ? _c("p", { staticClass: "m-0" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("pages.billing.yourFreeTrialExpiresOn")
                              ) +
                              " "
                          ),
                          _c(
                            "span",
                            { staticClass: "uppercase font-outfit-bold" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm
                                    .$moment(_vm.getCurrentUser.freeTrial)
                                    .format("DD MMM YYYY")
                                )
                              ),
                            ]
                          ),
                        ])
                      : _c("p", { staticClass: "m-0" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("pages.billing.yourFreeTrialExpiredOn")
                              ) +
                              " "
                          ),
                          _c(
                            "span",
                            { staticClass: "uppercase font-outfit-bold" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm
                                    .$moment(_vm.getCurrentUser.freeTrial)
                                    .format("DD MMM YYYY")
                                )
                              ),
                            ]
                          ),
                        ]),
                  ])
                : _vm._e(),
              !_vm.subscriptionIsFreeTrial && _vm.isSubscribed
                ? _c("div", { staticClass: "subscription-info-wrapper" }, [
                    _c(
                      "p",
                      {
                        staticClass:
                          "m-0 subscription-plan-name font-outfit-medium",
                      },
                      [_vm._v(" " + _vm._s(_vm.fullSubscriptionPlanName) + " ")]
                    ),
                    _vm.getLastPayment
                      ? _c("p", { staticClass: "m-0 price-per-month mb-2" }, [
                          _c("span", { staticClass: "font-outfit-bold" }, [
                            _vm._v(
                              _vm._s(_vm.getLastPayment.currency) +
                                " " +
                                _vm._s(_vm.getLastPayment.sale_gross)
                            ),
                          ]),
                          _vm._v(" " + _vm._s(_vm.paymentTypeText) + " "),
                        ])
                      : _vm._e(),
                    !_vm.isCurrentSubscriptionDeleted
                      ? _c("div", { staticClass: "next-bill-date-wrapper" }, [
                          _c("p", { staticClass: "m-0" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "pages.billing.yourSubscriptionRenewsOn"
                                  )
                                ) +
                                " "
                            ),
                            _c(
                              "span",
                              { staticClass: "uppercase font-outfit-bold" },
                              [_vm._v(_vm._s(_vm.nextBillDate))]
                            ),
                          ]),
                          _vm.getLastPayment
                            ? _c("p", { staticClass: "m-0" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t(
                                        "pages.billing.youNextPaymentWillBe"
                                      )
                                    ) +
                                    " "
                                ),
                                _c(
                                  "span",
                                  { staticClass: "uppercase font-outfit-bold" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.isSubscriptionLifetime
                                          ? "-"
                                          : `${_vm.getLastPayment.currency} ${_vm.getLastPayment.sale_gross}`
                                      )
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                        ])
                      : !_vm.isSubscriptionLifetime
                      ? _c("p", { staticClass: "m-0 text-red-light" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "pages.billing.yourSubscriptionHasBeenCanceledAndExpiresOn"
                                )
                              ) +
                              " "
                          ),
                          _c(
                            "span",
                            { staticClass: "uppercase font-outfit-bold" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.getCurrentUser.subscription.cancel_date
                                    ? _vm
                                        .$moment(
                                          _vm.getCurrentUser.subscription
                                            .cancel_date
                                        )
                                        .format("MMMM DD,YYYY")
                                    : _vm
                                        .$moment(
                                          _vm.currentUserSubscription
                                            .nextBillDate.date
                                        )
                                        .format("MMMM DD,YYYY")
                                )
                              ),
                            ]
                          ),
                        ])
                      : _vm._e(),
                  ])
                : !_vm.subscriptionIsFreeTrial && !_vm.isSubscribed
                ? _c("div", { staticClass: "subscription-info-wrapper" }, [
                    _c(
                      "p",
                      {
                        staticClass:
                          "m-0 subscription-plan-name font-outfit-medium",
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("pages.billing.none")) + " ")]
                    ),
                    _c("p", { staticClass: "m-0" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t("pages.billing.yourSubscriptionHasExpiredOn")
                          ) +
                          " "
                      ),
                      _c(
                        "span",
                        { staticClass: "uppercase font-outfit-bold" },
                        [
                          _vm._v(
                            _vm._s(
                              _vm
                                .$moment(
                                  _vm.getCurrentUser.subscription.cancel_date
                                )
                                .format("MMMM DD,YYYY")
                            )
                          ),
                        ]
                      ),
                    ]),
                  ])
                : _vm._e(),
              _c("current-subscription-buttons", {
                staticClass: "d-none d-sm-flex",
              }),
            ],
            1
          ),
          _vm.isDisabled
            ? _c("div", { staticClass: "cancel-wrapper" }, [
                _c("p", { staticClass: "account-canceled" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("pages.myProfile.accountCanceledMessage")) +
                      " "
                  ),
                ]),
              ])
            : _vm._e(),
        ]
      ),
      _c("current-subscription-buttons", { staticClass: "mt-4 d-sm-none" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }